const t = {
    icon: 'fa-paste',
    menus: {
        main: { section: 'forms', priority: 30 },
    },
    new: {
        attributes: ['ftemplate', 'name'],
        content: [['row', [['block', ['$ftemplate!', '$name']]]], '$submit'],
    },
    edit: {
        attributes: ['ftemplate', 'name'],
        content: [['row', [['block', ['$name!', '$ftemplate']]]], '$submit'],
    },
    display: {
        tabs: [{ name: 'infos' }, { name: 'definition' }, { name: 'versions' }],
    },
    list: {
        search: false,
        props: {
            searchSwitch: false,
        },
        columns: [
            { id: 'updatedAt', label: 'column_updatedat_label', flex: 0, width: 200, component: 'date' },
            { id: 'name', label: 'column_name_label', flex: 1 } as any,
            { id: 'ftemplate', label: 'column_ftemplate_label', component: 'ftemplate', flex: 0, width: 300 } as any,
            { id: 'status', label: 'column_status_label', component: 'status', flex: 0, width: 150 } as any,
        ],
        globalActions: ['add'],
        actions: ['display', 'edit', 'delete'],
    },
};

export default t;
